import { render, staticRenderFns } from "./RoomTypeCalendar.vue?vue&type=template&id=67790d36&scoped=true&"
import script from "./RoomTypeCalendar.vue?vue&type=script&lang=js&"
export * from "./RoomTypeCalendar.vue?vue&type=script&lang=js&"
import style0 from "./RoomTypeCalendar.vue?vue&type=style&index=0&id=67790d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67790d36",
  null
  
)

export default component.exports